import { ApiPostRequest } from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Exchange DO',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/conf',
      },
      {
        text: 'Exchange DO',
        href: '/adm/conf/exchange-do',
        active: true,
      },
    ],
    showmodal: false,
    export: 0,
    detail: false,
    form: {
      old_prefix: '',
      old_number: '',
      old_do: '',
      old_seal: '',
      new_prefix: '',
      new_number: '',
      new_do: '',
      new_seal: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeExchangeDO(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async submitUpdate({ commit, state, dispatch }) {
    commit('changeExchangeDO', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(
      `conf/container/exchange-do`,
      data.form,
      state.data.form
    );

    commit('changeExchangeDO', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },
};
